import { INewbuilding } from '../../types/newbuilding';

export function getNewbuildingReviewStat(newbuilding: INewbuilding) {
  return newbuilding.reviewStat || { reviewCountText: 'Нет отзывов', totalRate: 0, reviewCount: 0 };
}
